// extracted by mini-css-extract-plugin
module.exports = {"icon":"SideNav_icon__67_ZO"};